<template>
  <card
    class="wide-card"
    page="login"
    style="overflow:visible;"
  >
    <label class="top-label">INDICATE COUNSELOR PREFERENCES</label>
    <br />
    <label class="mb-0">Share any preferences you may have, to help us suggest possible counselor matches for you.</label>
    <hr />
    <form-component>
      <form
        id="step-three"
        data-vv-scope="step-three"
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <label>Do you have a preferred language?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <input-select
              id="language"
              v-model="language"
              name="language"
              display-field="name"
              :placeholder="null"
              :options="languageOptions"
              :error="errors.first('step-three.language')"
            />
          </div>
        </div>
        <label>Do you have a preference for the gender identity of your counselor?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <input-select
              id="gender"
              v-model="gender"
              name="gender"
              type="select"
              :placeholder="null"
              :options="counselorPreferenceGenderOptions"
            />
          </div>
        </div>
        <label>Do you have a preference for the ethnicity of your counselor?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <ethnicity-select
              id="ethnicity"
              v-model="ethnicity"
              name="ethnicity"
              empty-label="No Preference"
            />
          </div>
        </div>
        <label>Do you have a preference for the religion of your counselor?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <input-select
              id="religion"
              v-model="religion"
              name="religion"
              :placeholder="null"
              :options="[
                { id: '', display_label: 'No Preference' },
                { id: 'agnostic', display_label: 'Agnostic' },
                { id: 'atheist', display_label: 'Atheist' },
                { id: 'catholic', display_label: 'Catholic' },
                { id: 'hindu', display_label: 'Hindu' },
                { id: 'jewish', display_label: 'Jewish' },
                { id: 'mormon', display_label: 'Mormon' },
                { id: 'muslim', display_label: 'Muslim' },
                { id: 'protestant', display_label: 'Protestant' },
                { id: 'unaffiliated', display_label: 'Unaffiliated' },
                { id: 'other', display_label: 'Other' }
              ]"
            />
          </div>
        </div>
        <label>Would you prefer a LGBTQ+ counselor?</label>
        <div class="form-row hide-label">
          <div class="col-12">
            <input-select
              id="lgbtqPreference"
              v-model="lgbtqPreference"
              name="lgbtqPreference"
              :placeholder="null"
              :options="[
                { id: 'yes', display_label: 'Yes' },
                { id: '', display_label: 'No Preference' }
              ]"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-5 offset-md-2 order-md-2 mb-md-0 mb-3">
            <button
              class="btn btn--primary"
              :disabled="saving"
              type="submit"
            >
              <span class="text-center">Finish</span>
              <span class="float-right">
                <font-awesome-icon v-if="!saving" :icon="['fas', 'circle-check']" size="lg" />
                <font-awesome-icon
                  v-else
                  :spin="true"
                  :icon="['fas', 'spinner']"
                  class="icon alt"
                />
              </span>
            </button>
          </div>
          <div class="col-12 col-md-5 order-md-1">
            <button
              class="btn btn--secondary border"
              :disabled="saving"
              type="button"
              @click="$emit('back')"
            >
              <span class="float-left">
                <font-awesome-icon :icon="['fas', 'arrow-left']" size="lg" />
              </span>
              <span class="text-center">Back</span>
            </button>
          </div>
        </div>
      </form>
    </form-component>
  </card>
</template>

<script>
import EthnicitySelect from '@/components/inputs/EthnicitySelect.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import FormComponent from '@/components/FormComponent.vue';
import Card from '@/components/Card.vue';
import genderOptions from '@/helpers/mixins/gender-options';
import UserClient from '@/api/UserClient';
import StudentClient from '@/api/StudentClient';

export default {
    name: 'CounselorPreferences',
    components: {
        EthnicitySelect,
        FormComponent,
        InputSelect,
        Card
    },
    mixins: [genderOptions],
    data() {
      return {
        userClient: new UserClient(this.$http),
        studentClient: new StudentClient(this.$http),
        ethnicity: '',
        gender: '',
        lgbtqPreference: '',
        religion: '',
        language: '0',
        languageOptions: [],
        saving: false,
        userId: this.$store.getters.currentUser.id
      }
    },
    async mounted() {
      const response = await this.userClient.getAvailableCounselorLanguagesForUser(this.userId);
      this.languageOptions = [{ id: '0', name: 'English' }, ...response.languages.filter((l) => l.name !== 'English')];
    },
    methods:{
      async save() {
        this.saving = true;
        try {
          await this.userClient.setUserCounselorPreferences(
            this.userId,
            this.ethnicity,
            this.gender,
            this.religion,
            this.language,
            this.lgbtqPreference === 'yes',
            null);

          await this.userClient.setUserWelcomeFlowComplete(this.userId);
          await this.studentClient.scorePreferences(this.userId)

          this.$emit('complete', null);
        } catch (error) {
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed to Save. Please try again!', error: true,
          });
        } finally {
          this.saving = false;
        }
      }
    }
  }
  </script>

<style lang="scss" scoped>
  .wide-card {
    max-width: 600px;
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  </style>
